// Accès secret aux réglages : un double appui (toucher) ou un double clic (souris) sur « 0cog™ », dans les mentions légales (pied de
// l'appli et fenêtre « À propos »). Rien n'indique cet accès : le texte ne change pas d'aspect. Le même détecteur sert au toucher et à la
// souris (événement pointerup, pas de zoom au double appui sur mobile). Tout est local : aucune donnée n'est envoyée.
import { createDoubleTap } from '../core/doubleTap.js';

/** Le texte qui sert de zone secrète, dans les mentions légales (« un jeu 0cog™ », « 0cog™ est une marque de 0cog Inc. »). */
export const SECRET_TEXT = '0cog™';
export const SECRET_CLASS = 'secret-0cog';

/**
 * Enveloppe la première occurrence de « 0cog™ » du texte de `el` dans une zone secrète (<span class="secret-0cog">). Le reste du texte est
 * inchangé. À rappeler après chaque changement de langue, qui remplace le texte de l'élément. Seulement du texte et des nœuds créés ici.
 * @param {HTMLElement|null} el
 */
export function markSecret(el) {
  if (!el) return;
  const text = el.textContent ?? '';
  const at = text.indexOf(SECRET_TEXT);
  if (at < 0) return;
  const zone = document.createElement('span');
  zone.className = SECRET_CLASS;
  zone.textContent = SECRET_TEXT;
  const nodes = [];
  if (at > 0) nodes.push(document.createTextNode(text.slice(0, at)));
  nodes.push(zone);
  const rest = text.slice(at + SECRET_TEXT.length);
  if (rest) nodes.push(document.createTextNode(rest));
  el.replaceChildren(...nodes);
}

/**
 * @param {object} options
 * @param {() => void} options.onOpen  appelé au double appui sur une zone secrète
 * @param {() => boolean} [options.canOpen]  faux quand une autre fenêtre bloque l'accès (astuces, compte, réglages déjà ouverts)
 * @param {EventTarget} [options.root]
 * @param {number} [options.doubleMs]  délai entre les deux appuis
 * @param {() => number} [options.now]
 * @returns {() => void} la fonction qui retire l'écouteur
 */
export function bindSettingsSecret({ onOpen, canOpen = () => true, root = document, doubleMs, now }) {
  const detector = createDoubleTap(() => onOpen(), { maxMs: doubleMs, now });
  const onPointerUp = (event) => {
    if (!event.isPrimary || event.button > 0) return;
    if (!event.target?.closest?.(`.${SECRET_CLASS}`)) {
      detector.reset(); // un appui ailleurs interrompt le double appui
      return;
    }
    if (!canOpen()) {
      detector.reset();
      return;
    }
    detector.tap(event);
  };
  root.addEventListener('pointerup', onPointerUp, true);
  return () => root.removeEventListener('pointerup', onPointerUp, true);
}
